export const preview_empty_video_url =
    "playertest.longtailvideo.com/adaptive/wowzaid3/playlist.m3u8";
